import renderPage from '../routes/route'

document.addEventListener('DOMContentLoaded', () => {
  renderPage()
})
